<template>
    <div class="saveOrUpdateCrud">
        <div v-if="checkTime && timeForm.status=='0'">
            <el-alert title="请按照要求上传相关文件" show-icon type="info" effect="dark" :closable="false"></el-alert>
            <el-button style="width: 100%;margin-top: 10px;font-size: 38px;color: red;font-weight: bold;letter-spacing:20px;margin-bottom: -10px" type="primary" @click="pay">缴费入口</el-button>
            <el-form :model="upsertForm"  :rules="rules" ref="upsertForm" label-width="100px" style="margin-top: 20px;border:dashed 1px cornflowerblue;padding-bottom: 20px" :inline="true"  :closable="false">
                <input type="hidden" :value="upsertForm.id">
                <div style="height: 60px;width: 100%;">
                    <el-alert v-if="upsertForm.status==0" show-icon title="待提交资格审查" type="warning" effect="dark" description="请按要求上传资格审查资料" :closable="false"></el-alert>
                    <el-alert v-if="upsertForm.status==1" show-icon title="资格审核文件已提交" type="warning" effect="dark" description="请等待审核结果" :closable="false"></el-alert>
                    <el-alert v-if="upsertForm.status==2" show-icon title="资格审核已通过" type="success" effect="dark" :description="upsertForm.reason" :closable="false"></el-alert>
                    <el-alert v-if="upsertForm.status==3" show-icon title="资格审核不通过" type="error" effect="dark" :closable="false"></el-alert>
                </div>
                <div v-if="upsertForm.status==0 || upsertForm.status==3">
                  <el-form-item label="        " :prop="'sysUploadFileItems.' + index + '.url'" :rules="{required: true, message: '请上传'+item.fileName}"  v-for="(item,index) in upsertForm.sysUploadFileItems">
                    <el-upload
                      class="avatar-uploader"
                      :action="uploadStudnetFileUrl"
                      :headers="{token:$store.getters.getToken}"
                      :show-file-list="false"
                      :on-success="handleFileSuccess"
                      :before-upload="beforeAvatarUpload"
                      accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG,.pdf,.PDF"
                      :data="{ index: index }">
                      <img v-if="item.url && !isPdfFile(item.url)" :src="config.resPre+item.url" class="avatar" :preview-src-list="[config.resPre+item.url]"></img>
                      <!-- PDF预览卡片（强制完全居中） -->
                      <div v-else-if="item.url && isPdfFile(item.url)" style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; margin: 0; padding: 0;">
                        <i class="el-icon-file-pdf" style="font-size: 60px; color: #e53935; margin-bottom: 10px;"></i>
                        <div style="font-size: 16px; color: #333; margin-bottom: 15px; text-align: center; width: 100%;">
                          {{ item.fileName }}上传成功
                        </div>
                        <button
                          @click.stop="previewPdf(item.url)"
                          style="padding: 6px 20px; background: #409EFF; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">
                          点击预览
                        </button>
                        <div style="font-size: 12px; color: red; margin-top: 10px; text-align: center; width: 100%;">
                          按钮外区域点击可重新上传
                        </div>
                      </div>
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div style="text-align: center;width:450px;font-size:12px">
                      {{item.fileName}}
                    </div>
                  </el-form-item>
                </div>
                <div v-else>
                  <el-form-item label="    "  :prop="'sysUploadFileItems.' + index + '.url'" :rules="{required: true, message: '请上传'+item.fileName}"  v-for="(item,index) in upsertForm.sysUploadFileItems">
                    <el-image v-if="item.url && !isPdfFile(item.url)" :src="config.resPre+item.url" class="avatar" :preview-src-list="[config.resPre+item.url]"></el-image>
                    <!-- PDF预览卡片（强制完全居中） -->
                    <div v-else-if="item.url && isPdfFile(item.url)" style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; margin: 0; padding: 0;">
                      <i class="el-icon-file-pdf" style="font-size: 60px; color: #e53935; margin-bottom: 10px;"></i>
                      <div style="font-size: 16px; color: #333; margin-bottom: 15px; text-align: center; width: 100%;">
                        {{ item.fileName }}上传成功
                      </div>
                      <button
                        @click.stop="previewPdf(item.url)"
                        style="padding: 6px 20px; background: #409EFF; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">
                        点击预览
                      </button>
                    </div>
                    <div style="text-align: center;width:450px;font-size:12px">
                      {{item.fileName}}
                    </div>
                  </el-form-item>
                </div>
            </el-form>
            <div class="dialog-footer" style="text-align: right;margin-bottom: 20px;margin-top: 20px">
                <el-button size="mini" style="width: 100%" v-if="upsertForm.status==0 || upsertForm.status==3" type="primary" @click="saveOrUpdate('upsertForm')">提 交</el-button>
                <el-button size="mini" style="width: 100%" v-else type="primary" disabled>提 交</el-button>
            </div>
        </div>
        <div v-else style="width: 600px;text-align: center;margin:auto;margin-top: 100px;">
            <el-card class="box-card" >
                <div slot="header" class="clearfix">
                    <span style="color: red">通知</span>
                </div>
                <div class="text item" style="color: red">
                    <p v-if="timeForm.status=='0'">资格审核文件上传时间为：{{timeForm.startTime}}~{{timeForm.endTime}}</p>
                    <p v-else>未到资格审核文件上传时间</p>
                    <p>如有疑问请联系学院老师</p>
                </div>
            </el-card>
        </div>
        <el-dialog :close-on-click-modal="false" title="缴费信息" :visible.sync="dialogVisible">
            <el-alert title="扫描下方二维码完成缴费" type="error" effect="dark" :closable="false" style="margin-bottom: 10px;margin-top: -20px"></el-alert>
            <div v-if="ddForm.type=='0'" style="color: red;text-align: center;font-size: 30px">
                {{ddForm.remark}}
            </div>
            <div style="text-align: center;margin: auto">
                <el-image v-if="ddForm.type=='1'" style="width: 300px; height: 300px" :src="config.resPre+ddForm.remark" :preview-src-list="[config.resPre+ddForm.remark]"></el-image>
            </div>
            <div v-if="ddForm.type=='2'" style="color: red;text-align: center;text-align: center;margin: auto;">
                <a :href="ddForm.remark" target="_blank" class="table-edit" style="font-size: 30px">{{ddForm.remark}}</a>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    let loading;
    export default {
        name: "sysStudentExamFileUpload",
        data(){
            return {
                config:config,
                uploadStudnetFileUrl:`${home}/sysStudentExam/uploadStudnetFileUrlByIndex`,
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    studentId:'',
                    year:'',
                    payImg:'',
                    idCardPositiveImg:'',
                    idCardSideImg:'',
                    scoreImg:'',
                    scoreType:'',
                    studentProofImg:'',
                    schoolReportImg:'',
                    diplomaImg:'',
                    otherImg:'',
                    status:'',
                    reason:'',
                    type:'',
                    schoolName:'',
                    updateTime:'',
                    createTime:'',
                    sysUploadFileItems:[],
                },
                rules: {
                    adminId: [
                        { required: true, message: '请输入操作人编', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    adminName: [
                        { required: true, message: '请输入操作人', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studentId: [
                        { required: true, message: '请输入学生编号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    year: [
                        { required: true, message: '请输入年份', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    payImg: [
                        {  required: true, message: '请上传报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）图片', trigger: 'blur' },
                    ],
                    idCardPositiveImg: [
                        { required: true, message: '请上传身份证正面（扫描件或高清照片）', trigger: 'blur' },
                    ],
                    idCardSideImg: [
                        { required: true, message: '请上传身份证反面（扫描件或高清照片）', trigger: 'blur' },
                    ],
                    scoreImg: [
                        { required: true, message: '请上传《教育部学籍在线验证报告》（pdf版，有效期在30天以上）', trigger: 'blur' },
                    ],
                    scoreType: [
                        { required: true, message: '请输入成绩类型', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studentProofImg: [
                        { required: true, message: '请上传报名申请表', trigger: 'blur' },
                    ],
                    diplomaImg: [
                        { message: '请上传毕业证书扫描件（或者高清照片）', trigger: 'blur' },
                    ],
                    schoolReportImg: [
                        { required: true, message: '请上传考生本人在专科(高职)期间成绩单（应盖有教务处或成绩专用章）', trigger: 'blur' },
                    ],
                    otherImg: [
                        { message: '请上传其他材料', trigger: 'blur' },
                    ],
                    status: [
                        { required: true, message: '请输入审核状态', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    reason: [
                        { required: true, message: '请输入审核备注', trigger: 'blur' },
                    ],
                    updateTime: [
                        { required: true, message: '请输入修改时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    createTime: [
                        { required: true, message: '请输入创建时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                },
                ticketTime:'',
                checkTime:'',
                ddForm:{},
                dialogVisible:false,
                timeForm:{

                },
                pdfDeaultUrl:require('../../assets/pdf.png'),
            }
        },
        created(){
            axios({
                url:`${home}/sysDdList/checkStudentExamTime`,
                method:'GET'
            }).then(res=>{
                this.timeForm = res.data;
                this.checkTime = res.data2;
                if(res.data2){
                    this.getExamInfo();
                    this.ddForm = res.data3;
                }
            }).catch(error=>{

            })

        },
        mounted(){

        },
        methods:{
            getExamInfo(){
              axios({
                  url:`${home}/sysStudentExam/getMyInfoExams`,
                  method:'GET'
              }).then(res=>{
                  Object.assign(this.upsertForm,res.data);
              }).catch(error=>{
              
              })
            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        this.upsertForm.status = 1;
                        axios({
                            url:`${home}/sysUploadFileItem/submitSysUploadFileItem`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                        }).catch(error=>{
                            //do something
                        })
                    }
                })
            },
            beforeAvatarUpload(file) {
                const isJPG = "image/jpeg,image/png,image/jpg,image/PNG,application/pdf,application/PDF,image/JPEG,image/JPG";
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (isJPG.indexOf(file.type)==-1) {
                    this.$message.error("材料上传只能是 jpeg/jpg/png/pdf 格式!");
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error("材料上传大小不能超过2MB!");
                    return false;
                }
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            pay(){
                this.dialogVisible = true;
            },
            handleFileSuccess(response, file, index){
              this.upsertForm.sysUploadFileItems[response.index].url=response.url;
              this.upsertForm.sysUploadFileItems[response.index].suffix=response.suffix;
              this.upsertForm.sysUploadFileItems[response.index].name=response.index;
              loading.close();
            },
          isPdfFile(url) {
            if (!url) return false;
            return url.toLowerCase().endsWith('.pdf');
          },
          // 预览PDF
          previewPdf(url) {
            window.open(this.config.resPre + url, '_blank');
          },
        }
    }
</script>
<style lang="scss">
.saveOrUpdateCrud{
  margin: 20px 0 0 10px;
  .el-form-item{
    margin-top: 20px;
  }
  .el-upload{
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
<style scoped lang="scss">
    
    .avatar-uploader{
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        height: 200px;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 450px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
    .avatar {
        width: 450px;
        height: 200px;
        display: block;
        padding: 0px;
    }
</style>
